import React, { useEffect } from "react";
import styled from "styled-components"; // Import styled-components
import GlobalStyles from 'styles/GlobalStyles';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "home/HomePage.js";


import Error404 from "pages/Error404.js";

import About from "pageson/AboutUs.js";
import ContactUs from "pageson/ContactUs.js";

import BlogIndex from "blog/pages/BlogIndex.js";
import BlogPost from "blog/pages/BlogPost.js";



import Header from "components//headers/light.js";
import Footer from "components/footers/FiveColumnDark.js";

// Styles globals pour garantir que le pied de page reste en bas
const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
`;

// Remonte en haut de page à chaque changement de route (React Router ne le fait pas tout seul),
// sauf quand on navigue vers une ancre (#references, #sommaire…).
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <AppContainer>
      <GlobalStyles />
      <Router>
        <ScrollToTop />
        <Header />
        <MainContent>
          <Routes>
            <Route path="/" element={<HomePage />} />

            {/* Blog */}
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/categorie/:category" element={<BlogIndex />} />
            <Route path="/blog/tag/:tag" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            {/* Anciennes URL : « Nos projets » est devenu le blog, /team renvoie vers l'équipe (page À propos) */}
            <Route path="/projets" element={<Navigate to="/blog" replace />} />
            <Route path="/team" element={<Navigate to="/about" replace />} />

            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactUs />} />

            <Route path="/rgpd" element={<Error404 />} />
            <Route path="/politique" element={<Error404 />} />
            <Route path="/conditions" element={<Error404 />} />
            <Route path="/avertissement" element={<Error404 />} />

            <Route path="*" element={<Error404 headingText="Page introuvable" />} />
          </Routes>
        </MainContent>
        <Footer />
      </Router>
    </AppContainer>
  );
}

export default App;
